import {
    fetchInfo,
    fetchProducts,
    createOrder
} from "@/api/modules/products/timetickets";

const InfoModel = function(info) {
    this.identifier = info.productTypeIdentifier;
    this.allowedPassengerTypeIds = info.allowedPassengerTypeIds.map(id =>
        parseInt(id)
    );
    this.maximumNumberOfPassengersPerItem =
        info.maximumNumberOfPassengersPerItem;
};

export const state = {
    info: null,
    fetchedPages: 0,
    totalPages: null,
    loadingProducts: false,
    products: []
};

export const mutations = {
    updateInfo: (state, payload) => {
        state.info = new InfoModel(payload);
    },
    updateProducts: (state, { fetchedPage, totalPages, products }) => {
        state.fetchedPages = fetchedPage;
        state.totalPages = totalPages;
        state.products = [...state.products, ...products];
    },
    setLoadingProducts: (state, loading) => {
        state.loadingProducts = loading;
    }
};

export const getters = {
    isEnabled: state => Boolean(state.info),
    isAllProductsFetched: state =>
        state.totalPages !== null && state.totalPages <= state.fetchedPages,
    isProductsLoading: state => state.loadingProducts,
    getProducts: state => state.products
};

export const actions = {
    fetchInfo: context => {
        return fetchInfo(true)
            .then(response => {
                if (!response.ok) throw new Error(response.responseBody);
                return response.responseBody;
            })
            .then(json => {
                context.commit("updateInfo", json);
            });
    },
    fetchProducts: context => {
        if (context.getters.isAllProductsFetched) return Promise.resolve(true);
        if (context.getters.isProductsLoading) return Promise.resolve(true);

        context.commit("setLoadingProducts", true);
        const page = context.state.fetchedPages + 1;
        return fetchProducts(page)
            .then(response => {
                if (!response.ok) throw new Error(JSON.stringify(response));
                const {
                    totalPages,
                    timeTicketProductList
                } = response.responseBody;
                context.commit("updateProducts", {
                    fetchedPage: page,
                    totalPages,
                    products: timeTicketProductList
                });
                return true;
            })
            .finally(() => {
                context.commit("setLoadingProducts", false);
            });
    },
    prepareOrder: (context, { departureInstant, calculatedPriceOre }) => {
        const {
            allowedPassengerTypeIds,
            maximumNumberOfPassengersPerItem
        } = context.state.info;
        if (departureInstant) {
            context.commit(
                "order/setDetails",
                { departureInstant, calculatedPriceOre },
                { root: true }
            );
        }
        context.commit(
            "passenger/updatePassengers",
            {
                passengerTypeIds: allowedPassengerTypeIds,
                maximumPassengers: maximumNumberOfPassengersPerItem
            },
            { root: true }
        );
        return Promise.resolve(true);
    },
    createOrder: context => {
        const passengers = context.rootGetters["passenger/getPassengers"].map(
            passenger => {
                return {
                    passengerTypeId: passenger.passengerType.id,
                    passengerTypeCount: passenger.count
                };
            }
        );
        const preparedDetails = context.rootGetters["order/getDetails"];
        const { departureInstant } = preparedDetails;
        if (!departureInstant) {
            throw new Error(
                "cannot create time ticket order without a departureInstant"
            );
        }

        return createOrder(departureInstant, passengers)
            .then(response => {
                if (response.ok) {
                    return response.responseBody;
                } else if (
                    response.status === 422 &&
                    response.responseBody.error === "TicketNotSellable"
                ) {
                    throw new Error("TicketNotSellable");
                } else {
                    throw new Error(JSON.stringify(response));
                }
            })
            .then(({ orderId, priceOre, ...details }) => {
                context.commit("order/setOrderId", orderId, { root: true });
                context.commit("order/setPriceOre", priceOre, { root: true });
                context.commit(
                    "order/setDetails",
                    {
                        ...preparedDetails,
                        ...details
                    },
                    { root: true }
                );
            });
    }
};
